(function () {
  if (window.__pioMotion) return;
  window.__pioMotion = true;
  var nodes = document.querySelectorAll(".pio-section");
  if (!nodes.length || !("IntersectionObserver" in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add("is-in");
      entry.target.classList.remove("is-pending");
      io.unobserve(entry.target);
    });
  }, { threshold: 0.12 });
  nodes.forEach(function (el) {
    if (el.classList.contains("pds") || el.hasAttribute("data-pds-reveal")) return;
    if (el.querySelector(".pds, .pds-sb, [data-specband]")) return;
    var rect = el.getBoundingClientRect();
    if (rect.bottom > 0 && rect.top < window.innerHeight) return;
    el.classList.add("pio-reveal", "is-pending");
    io.observe(el);
  });
})();
